import { TradingRuleSchema } from "../../api/trade-to-earn/trade-to-earn-rules";
import { CmsImageSchema } from "../cmsGlobal";
import z from "zod";

/**
 * @deprecated It should be removed once we have fully migrated the trade-to-earn module
 */
const EpochGroupSchema = z.object({
  id: z.number().optional().nullable(),
  duration: z.number().optional().nullable(),
  start: z.coerce.date(),
  end: z.coerce.date(),
  isPaused: z.boolean().optional().nullable(),
  isPausedFrom: z.string().optional().nullable(),
  production: z.boolean(),
  rule: z
    .string()
    .transform((val) => JSON.parse(val))
    .pipe(TradingRuleSchema),
  prizePoolToken: z.string().optional().nullable(),
  exchangeIds: z
    .object({
      id: z.number(),
      exchangeIds: z.array(z.string()),
    })
    .optional()
    .nullable(),
  limitOrder: z.boolean().optional().nullable(),
  maxDefiAddressesByExchangeUserId: z.number().optional().nullable(),
  defiAddressBlockingPeriod: z.enum(["day", "epoch"]).optional().nullable(),
  onlyHubUserWithNoTradeEventsBefore: z.string().optional().nullable(),
  rewardToken: z.string().optional().nullable(),
  cooldownEnd: z.string().optional().nullable(),
});
export type CmsEpochGroup = z.infer<typeof EpochGroupSchema>;

const TradingCampaignDescriptionSchema = z.object({
  id: z.number(),
  conditionalRenderingFromDate: z.coerce.date().optional().nullable(),
  rule: z.string().optional().nullable(),
  content: z.string(),
});
export type CmsTradingCampaignDescription = z.infer<typeof TradingCampaignDescriptionSchema>;

const CmsCampaignPartnerSchema = z.object({
  id: z.number(),
  attributes: z.object({
    name: z.string(),
    description: z.string(),
    marketCap: z.string().optional().nullable(),
    allTimeLow: z.number().optional().nullable(),
    allTimeHigh: z.number().optional().nullable(),
    socials: z.array(
      z.object({
        id: z.number(),
        name: z.enum(["x", "discord", "telegram", "github"]),
        url: z.string(),
      }),
    ),
    websiteUrl: z.string().optional().nullable(),
    coinGeckoUrl: z.string().optional().nullable(),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
    publishedAt: z.coerce.date(),
    icon: z.object({ data: CmsImageSchema.optional().nullable() }).optional().nullable(),
  }),
});
export type CmsCampaignPartner = z.infer<typeof CmsCampaignPartnerSchema>;

export const CmsTradingCampaignSchema = z.object({
  id: z.number(),
  attributes: z.object({
    name: z.string(),
    title: z.string(),
    shortDescription: z.string(),
    tokenSymbol: z.string(),
    prizePool: z.string(),
    prizePoolToken: z.string(),
    dailyPrizePool: z.string().optional().nullable(),
    updatedAt: z.coerce.date(),
    publishedAt: z.coerce.date(),
    createdAt: z.coerce.date(),
    production: z.boolean(),
    networkReward: z.array(z.string()),
    startedAt: z.coerce.date(),
    endedAt: z.coerce.date(),
    visibility: z.enum(["public", "private"]).optional().nullable(),
    privateCampaignPartner: z.string().optional().nullable(),
    privateCampaignUtm: z.string().optional().nullable(),
    rewardVaultAddressProduction: z.string().optional().nullable(),
    rewardVaultAddressStaging: z.string().optional().nullable(),
    rewardVaultAddressDevelopment: z.string().optional().nullable(),
    uniqueParticipationByUser: z.boolean().optional().nullable(),
    rewardToken: z.string().optional().nullable(),
    alertSelfTrading: z.boolean().optional().nullable(),
    slippageThreshold: z.number().optional().nullable(),
    requireTelegramVerification: z.boolean().optional().nullable(),
    requireTwitterVerification: z.boolean().optional().nullable(),
    requireDiscordVerification: z.boolean().optional().nullable(),
    maxTradeAmountUSD: z.number().optional().nullable(),

    EpochGroups: z.array(EpochGroupSchema).optional().nullable(),

    descriptions: z.array(TradingCampaignDescriptionSchema).optional().nullable(),

    icon: z.object({ data: CmsImageSchema.optional().nullable() }).optional().nullable(),

    exchangeIds: z
      .object({
        id: z.number(),
        exchangeIds: z.array(z.string()).nullable(),
      })
      .optional()
      .nullable(),

    tokenIcon: z.object({ data: CmsImageSchema.optional().nullable() }).optional().nullable(),

    privateCampaignUtms: z
      .object({
        data: z.array(
          z.object({
            id: z.number(),
            attributes: z.object({
              value: z.string(),
              createdAt: z.coerce.date(),
              updatedAt: z.coerce.date(),
            }),
          }),
        ),
      })
      .optional()
      .nullable(),

    campaignPartners: z
      .object({
        data: z.array(CmsCampaignPartnerSchema),
      })
      .optional()
      .nullable(),
  }),
});

export type CMSTradingCampaign = z.infer<typeof CmsTradingCampaignSchema>;
